import { render, staticRenderFns } from "./SaltoSites.vue?vue&type=template&id=4184f22e&"
import script from "./SaltoSites.vue?vue&type=script&lang=ts&"
export * from "./SaltoSites.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports